var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBoxGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1614",
    "data-name": "Group 1614",
    transform: "translate(6839 -11270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1428",
    "data-name": "Rectangle 1428",
    transform: "translate(-6839 11270)",
    fill: "none",
    stroke: "#aaa",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 231,
    rx: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 216,
    height: 216,
    rx: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1613",
    "data-name": "Group 1613",
    transform: "translate(-1 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1429",
    "data-name": "Rectangle 1429",
    width: 103,
    height: 16,
    rx: 8,
    transform: "translate(-6774 11377)",
    fill: "#aaa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 103,
    height: 16,
    rx: 8,
    transform: "translate(-6714.5 11333.5) rotate(90)",
    fill: "#aaa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBoxGray);
export default __webpack_public_path__ + "static/media/plus-box-gray.68d67c970e271f9b9c4b21510c4b3679.svg";
export { ForwardRef as ReactComponent };